/* Kaufberater: question, filtering and navigation rules; paint calculations use the existing paint-calculator. */
(() => {
  'use strict';
  const options = (labels) => labels.map((label) => ({ value: label, label }));
  const PROJECTS = [
    { value: 'paint', label: 'Wände streichen', collection: 'wandfarben', note: 'Farbe, die zu Deinem Zuhause passt' },
    { value: 'wallpaper', label: 'Wände tapezieren', collection: 'tapete', note: 'Neue Muster. Neue Atmosphäre.' },
    { value: 'wood', label: 'Holz schützen & gestalten', collection: 'holzlasuren', note: 'Dein Holz in seinem schönsten Look' },
    { value: 'film', label: 'Möbel & Oberflächen aufwerten', collection: 'klebefolie', note: 'Ein neuer Look für Deine Lieblingsstücke' }
  ];
  const PATTERN_CATEGORIES = [
    { value: 'tapete_abstraktaquarell', label: 'Abstrakt & Aquarell' },
    { value: 'tapete_mustertapete_blumennatur', label: 'Blumen & Natur' },
    { value: 'tapete_mustertapete_klassischvintage', label: 'Klassisch & Vintage' },
    { value: 'tapete_mustertapete_leinenoptik', label: 'Leinenoptik' },
    { value: 'tapete_mustertapete_wandoptik', label: 'Wandoptik' },
    { value: 'tapete_mustertapete_tiere', label: 'Tiere' },
    { value: 'tapete_mustertapete_landschaft', label: 'Landschaft' },
    { value: 'tapete_mustertapete_architektur', label: 'Architektur' }
  ];
  const PHOTO_CATEGORIES = [
    { value: 'fototapeten_abstrakt', label: 'Abstrakt' },
    { value: 'fototapeten_architektur', label: 'Architektur' },
    { value: 'fototapeten_floral', label: 'Floral' },
    { value: 'fototapeten_kinder', label: 'Kinder' },
    { value: 'fototapeten_klassisch', label: 'Klassisch' },
    { value: 'fototapeten_landschaft', label: 'Landschaft' },
    { value: 'fototapeten_natur', label: 'Natur' },
    { value: 'fototapeten_tiere', label: 'Tiere' },
    { value: 'fototapeten_wandoptik', label: 'Wandoptik' }
  ];
  const PAPER_COLORS = {
    pattern: ['Blau', 'Bunt', 'Beige', 'Weiß', 'Creme', 'Grau', 'Schwarz', 'Grün', 'Türkis', 'Gelb', 'Braun', 'Rosa', 'Rot', 'Orange', 'Lila', 'Hellblau', 'Pink', 'Greige', 'Gold'],
    photo: ['Rot', 'Rosa', 'Bunt', 'Blau', 'Grau', 'Weiß', 'Grün', 'Beige', 'Gelb', 'Schwarz', 'Braun', 'Orange', 'Gold', 'Lila', 'Anthrazit', 'Rotbraun', 'Petrol', 'Hellblau', 'Creme', 'Violett', 'Türkis']
  };
  // Verified existing shop collections, including their historic misspelled handles.
  const PAINT_COLORS = [
    ['Beige', 'beige', 'beige'], ['Blau', 'blau', 'blau'], ['Braun', 'braun-erdtone', 'braun-erdtone'],
    ['Gelb', 'gelb', 'gelb'], ['Grau', 'grau', 'grau'], ['Grün', 'grun', 'gelb-kopie'],
    ['Orange', 'orange', 'orange'], ['Petrol', 'petrol-turkis', 'petrol-turkis'],
    ['Rosa', 'rosa-pink', 'rosa-pink'], ['Rot', 'rot', 'rot'], ['Schwarz', 'schwarz', 'schwarz'],
    ['Lila', 'vioelt-lila', 'violet-lila']
  ];
  const FILMS = {
    wood: ['ahorn', 'nussbaum', 'wurzelholz', 'fichte-grau', 'fichte-beige', 'eiche-weiss', 'buche-natur'],
    modern: ['struktur-schwarz', 'fichte-grau', 'eiche-weiss', 'salbei', 'anthrazit', 'weiss', 'taupe', 'schwarz', 'rot', 'hellgrau'],
    elegant: ['nussbaum', 'wurzelholz', 'struktur-schwarz', 'eiche-weiss', 'salbei', 'anthrazit', 'taupe', 'schwarz']
  };
  const WOOD_OUTDOOR_OBJECTS = new Set(['Gartenmöbel', 'Zaun', 'Sichtschutz', 'Gartenhaus']);
  const WOOD = {
    Anthrazit: 'holzlasur-anthrazit-fur-innen-und-aussen-2-5-liter',
    Teak: 'holzlasur-teak-fur-innen-und-aussen-2-5-liter',
    Nussbaum: 'holzlasur-nussbaum-fur-innen-und-aussen-2-5-liter',
    Kiefer: 'holzlasur-kiefer-fur-innen-und-aussen-2-5-liter',
    Farblos: 'holzlasur-farblos-fur-innen-und-aussen-2-5-liter',
    Eiche: 'holzlasur-eiche-fur-innen-und-aussen-2-5-liter',
    Palisander: 'holzlasur-anthrazit-fur-innen-und-aussen-2-5-liter-1'
  };
  const EXTRAS = { roller: 'Farbrolle', brush: 'Pinsel', cover: 'Abdeckmaterial', tape: 'Malerkrepp', tray: 'Farbwanne', paste: 'Vliestapetenkleister', wallbrush: 'Tapezierbürste', press: 'Andrückroller', woodbrush: 'Lasurpinsel' };
  const normalize = (s) => String(s).trim().normalize('NFC').toLocaleLowerCase('de-DE');
  const CONSULTATION_STEP = { id: 'consultation', label: 'Beratung', title: 'Wir beraten Dich gerne persönlich!' };
  const SPECIAL_PAINT_ROOMS = new Set(['Bad', 'Waschküche', 'Keller']);
  const paintRooms = (a) => Array.isArray(a.paintRoom) ? a.paintRoom : a.paintRoom ? [a.paintRoom] : [];
  const onlySpecialPaintRooms = (a) => a.project === 'paint' && paintRooms(a).length > 0 && paintRooms(a).every((room) => SPECIAL_PAINT_ROOMS.has(room));
  const requiresConsultation = (a) => a.project === 'paint'
    ? !onlySpecialPaintRooms(a) && a.usage === 'Feuchtere Umgebung'
    : a.project === 'wallpaper' && ['Bad', 'Waschküche'].includes(a.paperRoom);
  const question = (id, title, label, values, multi = false, layout = '') => ({ id, title, label, options: values, multi, layout });
  function paperColorsFor(products, category, look) {
    const collection = look === 'pattern' ? 'mustertapeten' : look === 'photo' ? 'fototapeten' : null;
    if (!collection) return [];
    const tags = new Set(products.filter((product) => product.collections.includes(collection) && product.collections.includes(category)).flatMap((product) => product.tags.map(normalize)));
    return PAPER_COLORS[look].filter((color) => tags.has(normalize('KB_' + color)));
  }
  function steps(a, paperColorOptions) {
    const result = [question('project', 'Was möchtest Du verschönern?', 'Dein Projekt', PROJECTS, false, 'project')];
    if (a.project === 'paint') {
      const special = paintRooms(a).filter((room) => SPECIAL_PAINT_ROOMS.has(room));
      const regular = paintRooms(a).filter((room) => !SPECIAL_PAINT_ROOMS.has(room));
      result.push(
        question('paintRoom', 'Wo möchtest Du streichen?', 'Räume', [...options(['Wohnzimmer', 'Schlafzimmer', 'Kinderzimmer', 'Küche', 'Flur', 'Keller', 'Bad', 'Waschküche']), { value: 'Außenbereich', label: 'Fassade' }], true),
        { ...question('usage', special.length ? 'Wie werden Deine übrigen Räume beansprucht?' : 'Wie wird die Fläche beansprucht?', 'Beanspruchung', [
          ...options(['Normal', 'Häufig berührt / stark beansprucht']),
          ...options(['Feuchtere Umgebung']),
          ...options(['Ich bin mir nicht sicher'])
        ]), hint: special.length ? 'Diese Frage gilt nur für ' + regular.join(', ') + '. ' + special.join(', ') + ' werden separat berücksichtigt.' : '' },
        question('wishes', 'Was ist Dir besonders wichtig?', 'Deine Wünsche', options(['Hohe Deckkraft', 'Besonders strapazierfähig', 'Geruchsarm', 'Einfach zu verarbeiten']), true)
      );
      result.push(question('paintColor', 'Welche Farbrichtung gefällt Dir?', 'Farbrichtung', PAINT_COLORS.map(([name]) => ({ value: name, label: name === 'Braun' ? 'Braun / Erdtöne' : name === 'Petrol' ? 'Petrol / Türkis' : name === 'Rosa' ? 'Rosa / Pink' : name === 'Lila' ? 'Violett / Lila' : name })), false, 'color'));
      result.push({ id: 'paintArea', title: 'Wie viele Quadratmeter möchtest Du gestalten?', label: 'Fläche', layout: 'paint-calculator' });
      result.push(question('owned', 'Was hast Du bereits zuhause?', 'Werkzeuge', [
        ...['roller', 'brush', 'cover', 'tape', 'tray'].map((key) => ({ value: key, label: EXTRAS[key] })),
        { value: 'none', label: 'Noch nichts' }
      ], true));
      if (onlySpecialPaintRooms(a)) result.splice(2);
    }
    if (a.project === 'wallpaper') {
      result.push(question('paperLook', 'Welchen Look möchtest Du?', 'Look', [
        { value: 'plain', label: 'Einfarbig / dezent' }, { value: 'structure', label: 'Struktur' },
        { value: 'pattern', label: 'Mustertapete' }, { value: 'photo', label: 'Fototapete' }, { value: 'unsure', label: 'Noch unsicher' }
      ], false, 'look'));
      if (['structure', 'unsure'].includes(a.paperLook)) result.push(question('overpaint', 'Möchtest Du die Tapete später überstreichen?', 'Überstreichen', options(['Ja', 'Nein', 'Weiß ich noch nicht'])));
      if (['pattern', 'photo'].includes(a.paperLook)) {
        result.push(question('paperStyle', 'Welche Kategorie gefällt Dir?', 'Kategorie', a.paperLook === 'pattern' ? PATTERN_CATEGORIES : PHOTO_CATEGORIES));
        result.push(question('paperColors', 'Welchen Farbstil suchst Du?', 'Farben', options(paperColorOptions?.get(a.paperStyle) || []), true, 'color'));
      }
      result.push(question('paperRoom', 'Welchen Raum möchtest Du gestalten?', 'Raum', options(['Wohnzimmer', 'Schlafzimmer', 'Kinderzimmer', 'Flur', 'Küche', 'Büro', 'Bad', 'Waschküche'])));
      if (a.paperLook !== 'photo') result.push({ id: 'paperArea', title: 'Gebe die Maße Deiner Wände an.', label: 'Maße', layout: 'wallpaper-calculator' });
    }
    if (a.project === 'wood') result.push(
      question('woodObject', 'Was möchtest Du lasieren?', 'Dein Holz', [
        { value: 'Gartenmöbel', label: 'Gartenmöbel aus Holz' },
        { value: 'Zaun', label: 'Zaun aus Holz' },
        { value: 'Sichtschutz', label: 'Sichtschutz aus Holz' },
        { value: 'Gartenhaus', label: 'Gartenhütte aus Holz' },
        { value: 'Altes Möbelstück', label: 'Altes Möbelstück aus Holz' },
        { value: 'Holzverkleidung', label: 'Verkleidung aus Holz' },
        { value: 'Sonstiges', label: 'Sonstiges aus Holz' }
      ]),
      ...(WOOD_OUTDOOR_OBJECTS.has(a.woodObject) ? [] : [question('woodPlace', 'Innen oder außen?', 'Einsatzort', options(['Innen', 'Außen']))]),
      question('woodLook', 'Welchen Look möchtest Du?', 'Look', Object.keys(WOOD).map((name) => ({ value: name, label: name === 'Farblos' ? 'Vorhandenen Farbton auffrischen' : name })))
    );
    if (a.project === 'film') result.push(
      question('filmObject', 'Was möchtest Du folieren?', 'Deine Oberfläche', options(['Schrank', 'Kommode', 'Tisch', 'Tür', 'Küche', 'Arbeitsplatte', 'Sonstiges'])),
      question('filmStyle', 'Welchen Stil möchtest Du?', 'Stil', [{ value: 'uni', label: 'Uni' }, { value: 'wood', label: 'Holz' }, { value: 'modern', label: 'Modern' }, { value: 'elegant', label: 'Elegant' }]),
      { id: 'filmArea', title: 'Wie groß ist Deine Oberfläche?', label: 'Maße', layout: 'film-calculator' }
    );
    if (requiresConsultation(a)) {
      const trigger = a.project === 'wallpaper' ? 'paperRoom' : 'usage';
      return [...result.slice(0, result.findIndex(step => step.id === trigger) + 1), CONSULTATION_STEP];
    }
    if (a.project) result.push({ id: 'results', label: 'Ergebnis', title: a.project === 'paint' ? 'Unsere Empfehlung für Dein Projekt' : 'Diese Produkte passen zu Deinem Projekt' });
    return result;
  }
  function updateAnswers(a, key, value) {
    const next = { ...a, [key]: value };
    if (key === 'project' && a.project !== value) return { project: value };
    if (key === 'paintRoom') {
      const selected = [...new Set(paintRooms(next))];
      const addedFacade = selected.includes('Außenbereich') && !paintRooms(a).includes('Außenbereich');
      next.paintRoom = addedFacade ? ['Außenbereich'] : selected.length > 1 ? selected.filter((room) => room !== 'Außenbereich') : selected;
    }
    if (key === 'paperLook' && a.paperLook !== value) {
      delete next.overpaint; delete next.paperStyle; delete next.paperColors;
    }
    if (key === 'paperStyle' && a.paperStyle !== value) delete next.paperColors;
    if (key === 'woodObject' && a.woodObject !== value) delete next.woodPlace;
    const active = new Set(steps(next).map((step) => step.id));
    for (const name of Object.keys(next)) if (!active.has(name)) delete next[name];
    if (next.project === 'wood' && WOOD_OUTDOOR_OBJECTS.has(next.woodObject)) next.woodPlace = 'Außen';
    return next;
  }
  function plan(a, config) {
    const root = PROJECTS.find((p) => p.value === a.project)?.collection;
    if (requiresConsultation(a)) return { root, groups: [], handles: [], tags: [], pending: 'Für dieses Projekt beraten wir Dich persönlich.', limit: 0 };
    if (onlySpecialPaintRooms(a)) return { root, groups: [], handles: [], tags: [], pending: 'Für diese Räume ist noch keine automatische Farbempfehlung verfügbar.', limit: 0 };
    const groups = [];
    let handles = null;
    let tags = [];
    let pending = '';
    if (a.project === 'paint') {
      if (a.usage === 'Normal') groups.push(['wandfarbe-universal', 'wandfarbe-premium']);
      if (a.usage === 'Häufig berührt / stark beansprucht') groups.push(['wandfarbe-premium']);
      const color = PAINT_COLORS.find(([name]) => name === a.paintColor);
      if (color) groups.push(['wandfarbe-universal-' + color[1], 'wandfarbe-premium-' + color[2]]);
    }
    if (a.project === 'wood') handles = [WOOD[a.woodLook]];
    if (a.project === 'film') {
      if (a.filmStyle === 'uni') groups.push(['mobelfolie']);
      else handles = (FILMS[a.filmStyle] || []).map((name) => 'mobelfolie-selbstklebend-' + name);
    }
    if (a.project === 'wallpaper') {
      if (a.paperLook === 'plain') groups.push(['einfarbigetapeten']);
      if (a.paperLook === 'pattern') groups.push(['mustertapeten']);
      if (a.paperLook === 'photo') groups.push(['fototapeten']);
      if (a.paperLook === 'structure') groups.push(['grandioso', 'vliestapete-protect', 'vliestapete-premium', 'vliestapete-pro', 'creative']);
      if (['structure', 'unsure'].includes(a.paperLook)) {
        if (a.overpaint === 'Ja') groups.push(['strukturvlies']);
        else if (a.paperLook === 'unsure' && a.overpaint === 'Nein') groups.push(['mustertapeten', 'fototapeten', 'einfarbigetapeten']);
      }
      if (['pattern', 'photo'].includes(a.paperLook)) {
        const categories = a.paperLook === 'pattern' ? PATTERN_CATEGORIES : PHOTO_CATEGORIES;
        const category = categories.find((item) => item.value === a.paperStyle);
        if (category) groups.push([category.value]);
        else pending = a.paperLook === 'pattern' ? 'Bitte wähle eine Mustertapeten-Kategorie aus.' : 'Bitte wähle eine Fototapeten-Kategorie aus.';
        tags = (a.paperColors || []).map((name) => normalize('KB_' + name));
      }
    }
    return { root, groups, handles, tags, pending, limit: a.project === 'wood' ? 1 : 8 };
  }
  function matches(product, filter) {
    if (filter.handles && !filter.handles.includes(product.handle)) return false;
    if (!filter.groups.every((group) => group.some((handle) => product.collections.includes(handle)))) return false;
    return !filter.tags.length || product.tags.some((tag) => filter.tags.includes(normalize(tag)));
  }
  function extrasFor(a) {
    if (requiresConsultation(a) || onlySpecialPaintRooms(a)) return [];
    if (a.project === 'paint') return ['roller', 'brush', 'cover', 'tape', 'tray'].filter((key) => !(a.owned || []).includes(key));
    if (a.project === 'wallpaper') return ['paste', 'wallbrush', 'press'];
    if (a.project === 'wood') return ['woodbrush', 'cover'];
    return [];
  }

  // One purchase model: optimise paint litres, or start a single-variant product at one bucket.
  function purchaseBundle(variants, requiredLitres) {
    const single = requiredLitres === null;
    if (single ? variants?.length !== 1 : !Number.isFinite(requiredLitres) || requiredLitres <= 0) return null;
    const packs = (variants || []).flatMap((v) => {
      const size = v.options?.length === 1 && String(v.options[0]).trim().match(/^(\d+(?:[.,]\d+)?)\s*(?:l|liter)$/i);
      const units = size ? Math.round(Number(size[1].replace(',', '.')) * 100) : 0;
      const max = Math.min(v.stock == null ? Infinity : Number(v.stock), v.max == null ? Infinity : Number(v.max));
      if (!v.available || !Number.isSafeInteger(v.id) || !Number.isSafeInteger(v.price) || v.price < 0 ||
          (!single && (!units || units > 100000)) || !(max >= 1) || (v.min != null && v.min !== 1) || (v.increment != null && v.increment !== 1)) return [];
      return [{ id: v.id, units, price: v.price, max: Math.floor(max), quantity: 0 }];
    });
    if (!packs.length) return null;
    if (single) return { requiredLitres: null, items: [{ ...packs[0], quantity: 1 }] };
    const gcd = (a, b) => b ? gcd(b, a % b) : a;
    const scale = packs.reduce((n, p) => gcd(n, p.units), packs[0].units);
    const target = Math.ceil(requiredLitres * 100 / scale - 1e-9);
    const limit = target + Math.max(...packs.map(p => p.units / scale)) - 1;
    // Bound memory/time for implausibly large inputs; keep manual product selection available.
    if (!Number.isSafeInteger(limit) || limit > 100000) return null;
    const costs = new Float64Array(limit + 1).fill(Infinity);
    const counts = new Uint32Array(limit + 1);
    const paths = new Array(limit + 1);
    costs[0] = 0;
    for (let index = 0; index < packs.length; index++) {
      const pack = packs[index], size = pack.units / scale;
      let remaining = Math.min(pack.max, Math.floor(limit / size));
      // Binary groups turn finite stock limits into a bounded knapsack.
      for (let group = 1; remaining > 0; group *= 2) {
        const quantity = Math.min(group, remaining), weight = size * quantity, price = pack.price * quantity;
        remaining -= quantity;
        for (let volume = limit; volume >= weight; volume--) {
          const previous = volume - weight, cost = costs[previous] + price, count = counts[previous] + quantity;
          if (cost < costs[volume] || (Number.isFinite(cost) && cost === costs[volume] && count < counts[volume])) {
            costs[volume] = cost; counts[volume] = count;
            paths[volume] = { index, quantity, previous: paths[previous] };
          }
        }
      }
    }
    let best = -1;
    for (let volume = target; volume <= limit; volume++) {
      if (Number.isFinite(costs[volume]) && (best < 0 || costs[volume] < costs[best])) best = volume;
    }
    if (best < 0) return null;
    for (let node = paths[best]; node; node = node.previous) packs[node.index].quantity += node.quantity;
    return { requiredLitres, items: packs.filter(p => p.quantity > 0).sort((a, b) => b.units - a.units) };
  }

  const api = { purchaseBundle, steps, plan, matches, updateAnswers, extrasFor, paperColorsFor, requiresConsultation, PAPER_COLORS, FILMS, WOOD };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || !window.customElements || customElements.get('kauf-berater')) return;
  const escape = (text) => String(text ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  class KaufBerater extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-advisor-config]').textContent);
      this.answers = {};
      this.current = 'project';
      this.visited = new Set(['project']);
      this.cache = new Map();
      this.paperColorOptions = new Map();
      this.generation = 0;
      this.questionNode = this.querySelector('[data-advisor-question]');
      this.progressNode = this.querySelector('[data-advisor-progress]');
      this.statusNode = this.querySelector('[data-advisor-status]');
      this.resultsNode = this.querySelector('[data-advisor-results]');
      this.consultationNode = this.querySelector('[data-advisor-consultation]');
      this.contactResponse = this.consultationNode.querySelector('[data-advisor-contact-result]')?.dataset.advisorContactResult || '';
      this.contactStorageKey = 'veluxis:kaufberater:consultation:' + location.pathname;
      if (this.contactResponse || new URLSearchParams(location.search).get('beratung') === '1') {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.contactStorageKey) || 'null');
          if (saved?.answers && Date.now() - saved.savedAt < 7200000 && requiresConsultation(saved.answers)) {
            this.answers = saved.answers;
            this.paperColorOptions = new Map(Array.isArray(saved.paperColorOptions) ? saved.paperColorOptions : []);
            this.visited = new Set(steps(this.answers).map(step => step.id));
            this.current = 'consultation';
          }
        } catch (_) {}
        if (this.contactResponse) this.current = 'consultation';
      }
      this.events = new AbortController();
      this.addEventListener('click', (event) => this.click(event), { signal: this.events.signal });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-advisor-contact-form]')) return;
        this.consultationNode.querySelector('[data-advisor-contact-summary]').value = this.consultationSummary();
        this.saveConsultationState();
        // Native Shopify submission keeps validation, error handling and CAPTCHA intact.
      }, { signal: this.events.signal, capture: true });
      this.addEventListener('paint-area-change', (event) => {
        if (this.current !== 'paintArea') return;
        this.answers = updateAnswers(this.answers, 'paintArea', event.detail);
        this.querySelector('[data-advisor-next]').disabled = !this.answered({ id: 'paintArea' });
      }, { signal: this.events.signal });
      this.addEventListener('film-area-change', (event) => {
        if (this.current !== 'filmArea') return;
        this.answers = updateAnswers(this.answers, 'filmArea', event.detail);
        this.querySelector('[data-advisor-next]').disabled = !this.answered({ id: 'filmArea' });
      }, { signal: this.events.signal });
      this.addEventListener('wallpaper-area-change', (event) => {
        if (this.current !== 'paperArea') return;
        this.answers = updateAnswers(this.answers, 'paperArea', event.detail);
        this.querySelector('[data-advisor-next]').disabled = !this.answered({ id: 'paperArea' });
      }, { signal: this.events.signal });
      this.render();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      const modal = document.getElementById(this.dataset.modalId);
      if (modal?.hasAttribute('open')) modal.hide();
      modal?.remove();
      this.initialized = false;
    }
    url(path) {
      const root = this.config.root.endsWith('/') ? this.config.root : this.config.root + '/';
      return new URL(root + path.replace(/^\//, ''), location.origin);
    }
    async dataPage(root, page, signal) {
      const url = this.url('collections/' + encodeURIComponent(root));
      url.searchParams.set('section_id', 'kaufberater');
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('page', page);
      const key = url.href;
      if (this.cache.has(key)) return this.cache.get(key);
      const response = await fetch(url, { signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Die Produkte konnten nicht geladen werden.');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = doc.querySelector('[data-advisor-products]');
      if (!node) throw new Error('Die Produktdaten sind derzeit nicht verfügbar.');
      const data = JSON.parse(node.textContent);
      if (data.collection !== root || data.sort !== 'best-selling' || Number(data.page) !== page) throw new Error('Die Produktreihenfolge konnte nicht geladen werden.');
      this.cache.set(key, data);
      return data;
    }
    consultationSummary() {
      return steps(this.answers, this.paperColorOptions).filter(step => step.options && this.answers[step.id]).map(step => {
        const values = Array.isArray(this.answers[step.id]) ? this.answers[step.id] : [this.answers[step.id]];
        return step.label + ': ' + values.map(value => step.options.find(option => option.value === value)?.label || value).join(', ');
      }).join('\n');
    }
    saveConsultationState() {
      if (!requiresConsultation(this.answers)) return;
      try {
        // Only selection answers, never name, email or the free-text description.
        sessionStorage.setItem(this.contactStorageKey, JSON.stringify({ answers: this.answers, paperColorOptions: [...this.paperColorOptions], savedAt: Date.now() }));
      } catch (_) { /* The native form remains usable when browser storage is blocked. */ }
    }
    renderConsultation() {
      this.consultationNode.hidden = this.current !== 'consultation';
      if (this.consultationNode.hidden) return;
      const fields = this.consultationNode.querySelector('[data-advisor-contact-fields]');
      fields.hidden = this.contactResponse === 'success';
      fields.disabled = fields.hidden;
      this.consultationNode.querySelectorAll('[data-advisor-contact-result]').forEach(node => {
        node.hidden = node.dataset.advisorContactResult !== this.contactResponse;
      });
      this.consultationNode.querySelector('[data-advisor-contact-summary]').value = this.consultationSummary();
      this.consultationNode.querySelector('[data-advisor-restart]').hidden = this.contactResponse !== 'success' && !!this.answers.project;
      if (this.contactResponse === 'success') {
        try { sessionStorage.removeItem(this.contactStorageKey); } catch (_) {}
      } else this.saveConsultationState();
    }
    click(event) {
      if (event.target.closest('[data-advisor-restart]')) {
        this.answers = {}; this.current = 'project'; this.visited = new Set(['project']); this.contactResponse = '';
        this.consultationNode.querySelector('form').reset();
        try { sessionStorage.removeItem(this.contactStorageKey); } catch (_) {}
        this.render(true);
        return;
      }
      const option = event.target.closest('[data-advisor-option]');
      if (option && !option.disabled) {
        this.contactResponse = '';
        const step = steps(this.answers, this.paperColorOptions).find((item) => item.id === this.current);
        const value = option.dataset.advisorOption;
        let next = value;
        if (step.multi) {
          const selected = new Set(step.id === 'paintRoom' ? paintRooms(this.answers) : this.answers[step.id] || []);
          if (selected.has(value)) selected.delete(value); else selected.add(value);
          if (step.id === 'owned' && value === 'none' && selected.has('none')) next = ['none'];
          else next = [...selected];
        }
        this.answers = updateAnswers(this.answers, step.id, next);
        this.render(false);
        [...this.querySelectorAll('[data-advisor-option]')].find((button) => button.dataset.advisorOption === value)?.focus({ preventScroll: true });
      }
      const back = event.target.closest('[data-advisor-back]');
      const go = event.target.closest('[data-advisor-go]');
      if (back || go) {
        const all = steps(this.answers, this.paperColorOptions);
        const target = go?.dataset.advisorGo || all[all.findIndex((item) => item.id === this.current) - 1]?.id;
        const targetIndex = all.findIndex((item) => item.id === target);
        const reachable = targetIndex >= 0 && all.slice(0, targetIndex).every((item) => this.answered(item));
        if (target && this.visited.has(target) && reachable) { this.current = target; this.render(true); }
      }
      const skipArea = event.target.closest('[data-advisor-skip-area]');
      if (skipArea && (['paintArea', 'filmArea', 'paperArea'].includes(this.current))) {
        this.answers = updateAnswers(this.answers, this.current, { skipped: true });
      }
      if (event.target.closest('[data-advisor-next]') || (skipArea && (['paintArea', 'filmArea', 'paperArea'].includes(this.current)))) {
        const all = steps(this.answers, this.paperColorOptions);
        const index = all.findIndex((item) => item.id === this.current);
        if (!this.answered(all[index])) return;
        const next = all[index + 1];
        if (next) { this.current = next.id; this.visited.add(next.id); this.render(true); }
      }
      const adjust = event.target.closest('[data-bundle-adjust]');
      if (adjust) this.adjustPurchaseBundle(adjust);
      const add = event.target.closest('[data-advisor-add-bundle], [data-advisor-add-extra]');
      if (add) this.addToCart(add);
      const product = event.target.closest('[data-advisor-open]');
      if (product) this.openProduct(product);
      if (event.target.closest('[data-advisor-retry]')) {
        if (this.current === 'paperColors' && ['pattern', 'photo'].includes(this.answers.paperLook)) this.loadPaperColors();
        else this.loadResults();
      }
    }
    answered(step) {
      const answer = step.id === 'paintRoom' ? paintRooms(this.answers) : this.answers[step.id];
      if (step.options?.some((option) => option.disabled && (step.multi ? (answer || []).includes(option.value) : answer === option.value))) return false;
      if (['filmArea', 'paperArea'].includes(step.id)) return answer?.skipped === true || answer?.valid === true;
      if (step.id === 'paintArea') return answer?.skipped === true || (Number.isFinite(answer?.area) && answer.area > 0);
      if (step.id === 'paperColors' && ['pattern', 'photo'].includes(this.answers.paperLook)) {
        const colors = this.paperColorOptions.get(this.answers.paperStyle);
        return !!colors && Array.isArray(answer) && answer.length > 0 && answer.every((color) => colors.includes(color));
      }
      return step.multi ? Array.isArray(answer) && answer.length > 0 : !!answer;
    }
    render(focus = false) {
      this.request?.abort();
      ++this.generation;
      const all = this.current === 'consultation' && this.contactResponse && !requiresConsultation(this.answers)
        ? [CONSULTATION_STEP] : steps(this.answers, this.paperColorOptions);
      const activeIds = new Set(all.map((item) => item.id));
      this.visited = new Set([...this.visited].filter((id) => activeIds.has(id)));
      if (!activeIds.has(this.current)) this.current = 'project';
      const index = all.findIndex((item) => item.id === this.current);
      const step = all[index];
      this.progressNode.innerHTML = '<ol>' + all.map((item, i) => {
        const complete = item.id !== 'results' && this.answered(item);
        const canVisit = this.visited.has(item.id) && i !== index;
        return '<li><button type="button" data-advisor-go="' + item.id + '" ' + (!canVisit ? 'disabled ' : '') + (i === index ? 'aria-current="step" ' : '') + 'aria-label="' + escape(item.label) + '"><span class="advisor__dot">' + (complete && i !== index ? '✓' : i + 1) + '</span><span class="advisor__step-label">' + escape(item.label) + '</span></button></li>';
      }).join('') + '</ol>';
      const results = step.id === 'results';
      const consultation = step.id === 'consultation';
      this.renderConsultation();
      this.resultsNode.hidden = !results;
      this.resultsNode.innerHTML = '';
      this.statusNode.textContent = '';
      this.querySelector('[data-advisor-back]').hidden = index === 0;
      const next = this.querySelector('[data-advisor-next]');
      this.querySelector('[data-advisor-skip-area]').hidden = !['paintArea', 'filmArea', 'paperArea'].includes(step.id);
      next.hidden = results || consultation;
      next.disabled = !this.answered(step);
      next.textContent = all[index + 1]?.id === 'results' ? 'Ergebnisse ansehen →' : 'Weiter →';
      this.questionNode.innerHTML = '<p class="advisor__step-count">' + (consultation ? 'PERSÖNLICHE BERATUNG' : results ? 'DEINE AUSWAHL' : 'SCHRITT ' + (index + 1) + (all.length > 1 ? ' VON ' + (all.length - 1) : '')) + '</p><h2 tabindex="-1">' + escape(step.title) + '</h2>' +
        (results ? (this.answers.project === 'paint' ? '<div data-advisor-paint-summary></div>' : '<p>Passend zu Deinen Antworten · nach Bestsellern sortiert</p>') : consultation || ['paintArea', 'filmArea', 'paperArea'].includes(step.id) ? '' : '<p class="advisor__hint">' + escape(step.hint || (step.id === 'paintRoom' ? 'Du kannst mehrere Räume auswählen. Die Fassade wählst Du separat von Innenräumen.' : step.multi ? 'Du kannst mehrere Antworten auswählen.' : 'Wähle die Antwort, die zu Deinem Projekt passt.')) + '</p><div class="advisor__options advisor__options--' + (step.layout || 'text') + '" role="group" aria-label="' + escape(step.title) + '">' + step.options.map((option) => this.optionMarkup(option, step)).join('') + '</div>') +
        (results && this.answers.project === 'wallpaper' && this.answers.paperLook !== 'photo' && this.answers.paperArea?.valid === true && !this.answers.paperArea.skipped ? '<p class="advisor__hint">Die berechnete Rollenanzahl gilt jeweils für alle von Dir angegebenen Wände zusammen.</p>' : '');
      if (focus) this.questionNode.querySelector('h2').focus({ preventScroll: true });
      if (results) this.loadResults();
      if (step.id === 'paintArea') this.mountPaintCalculator();
      if (step.id === 'paperArea') {
        const fragment = document.importNode(this.querySelector('[data-advisor-wallpaper-template]').content, true);
        const calculator = fragment.querySelector('wallpaper-calculator');
        customElements.upgrade(calculator);
        calculator.restore(this.answers.paperArea || {});
        this.questionNode.appendChild(fragment);
      }
      if (step.id === 'filmArea') {
        const fragment = document.importNode(this.querySelector('[data-advisor-film-template]').content, true);
        const calculator = fragment.querySelector('adhesive-film-calculator');
        customElements.upgrade(calculator);
        calculator.restore(this.answers.filmArea || {});
        this.questionNode.appendChild(fragment);
      }
      if (step.id === 'paperColors' && ['pattern', 'photo'].includes(this.answers.paperLook)) {
        if (!this.paperColorOptions.has(this.answers.paperStyle)) this.loadPaperColors();
        else if (!step.options.length) this.statusNode.textContent = 'Für diese Kategorie sind noch keine Farb-Tags hinterlegt. Bitte wähle eine andere Kategorie.';
      }
    }
    async loadPaperColors() {
      this.request?.abort();
      this.request = new AbortController();
      const signal = this.request.signal;
      const generation = this.generation;
      const category = this.answers.paperStyle;
      const look = this.answers.paperLook;
      this.querySelector('[data-advisor-next]').disabled = true;
      this.statusNode.textContent = 'Wir laden die verfügbaren Farben dieser Kategorie …';
      try {
        if (!(look === 'pattern' ? PATTERN_CATEGORIES : PHOTO_CATEGORIES).some((item) => item.value === category)) throw new Error('Ungültige Kategorie');
        const products = [];
        let pages = 1;
        for (let page = 1; page <= pages; page++) {
          signal.throwIfAborted();
          const data = await this.dataPage(category, page, signal);
          pages = data.pages;
          products.push(...data.products);
        }
        if (generation !== this.generation || signal.aborted || this.answers.paperStyle !== category) return;
        const colors = paperColorsFor(products, category, look);
        this.paperColorOptions.set(category, colors);
        this.answers.paperColors = (this.answers.paperColors || []).filter((color) => colors.includes(color));
        this.render(false);
      } catch (error) {
        if (generation !== this.generation || signal.aborted || error.name === 'AbortError') return;
        this.statusNode.textContent = 'Die verfügbaren Farben konnten nicht geladen werden. Bitte versuche es erneut.';
        this.questionNode.querySelector('.advisor__options').innerHTML = '<button type="button" class="button button--secondary" data-advisor-retry>Erneut versuchen</button>';
      }
    }
    async mountPaintCalculator() {
      const generation = this.generation;
      const special = paintRooms(this.answers).filter((room) => SPECIAL_PAINT_ROOMS.has(room));
      if (special.length) this.questionNode.insertAdjacentHTML('beforeend', '<p class="advisor__hint">Gib hier nur die Fläche für ' + escape(paintRooms(this.answers).filter((room) => !SPECIAL_PAINT_ROOMS.has(room)).join(', ')) + ' an. ' + escape(special.join(', ')) + ' werden separat berücksichtigt und sind nicht Teil dieser Mengenberechnung.</p>');
      const fragment = document.importNode(this.querySelector('[data-advisor-paint-template]').content, true);
      const calculator = fragment.querySelector('paint-calculator');
      customElements.upgrade(calculator);
      calculator.restore(this.answers.paintArea || {});
      this.questionNode.appendChild(fragment);
      this.request = new AbortController();
      try {
        const filter = plan(this.answers, this.config);
        calculator.products = filter.pending ? [] : await this.findProducts(filter, this.request.signal);
        if (generation !== this.generation) return;
        calculator.calculate();
      } catch (error) {
        if (generation !== this.generation || error.name === 'AbortError') return;
        calculator.products = [];
        calculator.calculate();
        this.statusNode.textContent = 'Die Reichweiten konnten nicht geladen werden. Deine Fläche bleibt gespeichert; wir versuchen es auf der Ergebnisseite erneut.';
      }
    }
    paintSummaryMarkup(products) {
      const a = this.answers;
      const rooms = paintRooms(a);
      const special = rooms.filter((room) => SPECIAL_PAINT_ROOMS.has(room));
      const regular = rooms.filter((room) => !SPECIAL_PAINT_ROOMS.has(room));
      const notices = special.map((room) => '<section class="advisor__notice"><h3>Für Dein' + (room === 'Keller' ? 'en Keller' : room === 'Bad' ? ' Bad' : 'e Waschküche') + '</h3><p>Für diesen Raum ist derzeit noch keine konkrete Farbe zugeordnet. Wir zeigen Dir dafür noch keine automatische Produkt- oder Mengenempfehlung.</p></section>').join('');
      if (onlySpecialPaintRooms(a)) return notices;
      const scope = special.length ? '<h3 class="advisor__why-title">Farbempfehlung für: ' + escape(regular.join(', ')) + '</h3><p class="advisor__paint-note">Die folgenden Farben und Mengen gelten nur für diese Räume, nicht für ' + escape(special.join(', ')) + '.</p>' : '';
      const calculator = customElements.get('paint-calculator');
      const skipped = a.paintArea?.skipped === true;
      const estimate = skipped ? null : calculator.estimate(products, a.paintArea?.area);
      const number = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });
      const room = regular.map((name) => name === 'Außenbereich' ? 'die Fassade' : name === 'Küche' ? 'in der Küche' : 'im ' + name).join(', ');
      const reasons = ['Du möchtest ' + room + ' streichen.'];
      const usage = {
        Normal: 'Die Fläche wird normal beansprucht.',
        'Häufig berührt / stark beansprucht': 'Die Fläche wird häufig berührt und stark beansprucht.',
        'Feuchtere Umgebung': 'Die Fläche befindet sich in einer feuchteren Umgebung.',
        'Ich bin mir nicht sicher': 'Bei der Beanspruchung bist Du noch unsicher.'
      };
      if (usage[a.usage]) reasons.push(usage[a.usage]);
      if (a.wishes?.length) reasons.push('Dir ist wichtig: ' + a.wishes.join(', ') + '.');
      const color = steps(a).find((step) => step.id === 'paintColor')?.options.find((option) => option.value === a.paintColor);
      if (color) reasons.push('Du möchtest Farbtöne in ' + color.label + '.');
      return notices + scope + (skipped
        ? '<p class="advisor__paint-note">Du hast die Flächenangabe übersprungen. Wir zeigen Dir passende Farben; die benötigte Menge lässt sich erst mit Deiner Fläche berechnen.</p>'
        : '<p class="advisor__paint-estimate">Deine Fläche: ' + escape(number.format(a.paintArea?.area || 0)) + ' m².' +
        (estimate ? ' ' + escape(calculator.formatEstimate(estimate)) : '') + '</p>' +
        (estimate ? '<p class="advisor__paint-note">Für 2 Anstriche, auf volle Liter aufgerundet. ' +
        (estimate.min !== estimate.max ? 'Die Spanne ergibt sich aus den unterschiedlichen Produktreichweiten. ' : '') +
        'Der tatsächliche Verbrauch hängt vom Untergrund und der Verarbeitung ab.</p>' : '')) +
        '<h3 class="advisor__why-title">Warum passt es zu Dir?</h3><ul class="advisor__reasons">' + reasons.map((reason) => '<li>' + escape(reason) + '</li>').join('') + '</ul>';
    }
    async findProducts(filter, signal) {
      const found = [];
      const seen = new Set();
      let page = 1;
      let pages = 1;
      do {
        signal?.throwIfAborted();
        const data = await this.dataPage(filter.root, page, signal);
        pages = data.pages;
        for (const product of data.products) {
          if (matches(product, filter) && !seen.has(product.id)) { found.push(product); seen.add(product.id); }
          if (found.length === filter.limit) break;
        }
        page++;
      } while (page <= pages && found.length < filter.limit);
      return found;
    }
    optionMarkup(option, step) {
      const answer = step.id === 'paintRoom' ? paintRooms(this.answers) : this.answers[step.id];
      const disabled = option.disabled || (step.id === 'owned' && (answer || []).includes('none') && option.value !== 'none');
      const selected = !disabled && (step.multi ? (answer || []).includes(option.value) : answer === option.value);
      const image = step.id === 'paperLook' ? this.config.lookImages?.[option.value] : option.collection ? this.config.images[option.collection] : null;
      const unsure = step.id === 'paperLook' && option.value === 'unsure';
      let visual = image ? '<img src="' + escape(image) + '" alt="" loading="lazy" width="600" height="400">' : '';
      if (unsure) visual = '<svg class="advisor__look-symbol" viewBox="0 0 300 256" aria-hidden="true" focusable="false"><circle cx="150" cy="128" r="66" fill="none" stroke="currentColor" stroke-width="3"/><path d="M128 106c0-30 46-30 46 0 0 18-24 19-24 36" fill="none" stroke="currentColor" stroke-width="9" stroke-linecap="round"/><circle cx="150" cy="163" r="5" fill="currentColor"/></svg>';
      if (step.layout === 'color') visual = '<span class="advisor__swatch advisor__swatch--' + escape(option.value) + '" aria-hidden="true"></span>';
      return '<button type="button" class="advisor__option' + (image || unsure ? ' advisor__option--visual' : '') + (selected ? ' is-selected' : '') + '" data-advisor-option="' + escape(option.value) + '" aria-pressed="' + selected + '" ' + (disabled ? 'disabled' : '') + '>' + visual + '<span class="advisor__option-copy"><span class="advisor__option-label">' + escape(option.label) + '</span>' + (option.note ? '<span class="advisor__option-note">' + escape(option.note) + '</span>' : '') + '</span><span class="advisor__selection" aria-hidden="true">' + (selected ? '✓' : '') + '</span></button>';
    }
    async loadResults() {
      if (requiresConsultation(this.answers)) {
        this.current = 'consultation'; this.visited.add('consultation'); this.render(true); return;
      }
      this.purchaseBundles = new Map();
      this.request?.abort();
      this.request = new AbortController();
      const signal = this.request.signal;
      const generation = ++this.generation;
      const filter = plan(this.answers, this.config);
      this.resultsNode.hidden = false;
      this.resultsNode.innerHTML = '';
      this.resultsNode.setAttribute('aria-busy', 'true');
      this.statusNode.textContent = 'Wir suchen passende Produkte für Dein Projekt …';
      try {
        if (filter.pending) {
          const summary = this.querySelector('[data-advisor-paint-summary]');
          if (summary) summary.innerHTML = this.paintSummaryMarkup([]);
          this.resultsNode.innerHTML = (onlySpecialPaintRooms(this.answers) ? '' : '<div class="advisor__notice">' + escape(filter.pending) + '</div>') + this.extrasMarkup();
          this.statusNode.textContent = '';
          return;
        }
        const found = await this.findProducts(filter, signal);
        if (generation !== this.generation) return;
        const summary = this.querySelector('[data-advisor-paint-summary]');
        if (summary) summary.innerHTML = this.paintSummaryMarkup(found);
        if (this.answers.project === 'paint' && !this.answers.paintArea?.skipped) {
          const estimate = customElements.get('paint-calculator').estimate(found, this.answers.paintArea?.area);
          if (estimate) for (const product of found) {
            const bundle = purchaseBundle(product.paintVariants, estimate.max);
            if (bundle) this.purchaseBundles.set(String(product.id), bundle);
          }
        }
        if (this.answers.project === 'wood') for (const product of found) {
          const bundle = purchaseBundle(product.purchaseVariants, null);
          if (bundle) this.purchaseBundles.set(String(product.id), bundle);
        }
        if (this.answers.project === 'film' && this.answers.filmArea?.valid && !this.answers.filmArea.skipped) {
          const calculator = customElements.get('adhesive-film-calculator');
          for (const product of found) {
            const result = calculator.estimate(product.filmVariants, this.answers.filmArea);
            if (!result) continue;
            const best = result.best;
            const number = value => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(value);
            this.purchaseBundles.set(String(product.id), { kind: 'film', requiredLitres: null, requiredQuantity: best.quantity,
              note: best.seams ? 'Mit Nahtstellen' : 'Ohne Nahtstellen',
              items: [{ id: best.id, quantity: best.quantity, max: best.max, price: best.price, units: 0,
                label: number(best.rollWidth * 100) + ' × ' + number(best.rollLength * 100) + ' cm' }] });
          }
        }
        if (this.answers.project === 'wallpaper' && this.answers.paperArea?.valid && !this.answers.paperArea.skipped) {
          for (const product of found) {
            if (product.isPhoto) continue;
            const best = customElements.get('wallpaper-calculator').recommend(product.wallpaperVariants, this.answers.paperArea);
            if (!best) continue;
            const number = value => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(value);
            this.purchaseBundles.set(String(product.id), { kind: 'wallpaper', requiredLitres: null, requiredQuantity: best.quantity,
              note: 'Voraussichtlicher Bedarf: ' + best.quantity + (best.quantity === 1 ? ' Rolle' : ' Rollen') + ' · inkl. Beschnitt und Musteranpassung',
              items: [{ id: best.id, quantity: best.quantity, max: best.max, price: best.price, units: 0,
                label: number(best.rollWidth) + ' × ' + number(best.rollLength) + ' m' }] });
          }
        }
        const empty = filter.tags.length ? 'Für diese Auswahl sind noch keine passenden Produkte mit den hinterlegten Farb-Tags gefunden worden.' : 'Für diese Auswahl wurden keine passenden Produkte gefunden.';
        this.resultsNode.innerHTML = found.length ? '<div class="advisor__grid">' + found.map((product) => this.cardMarkup(product)).join('') + '</div>' : '<div class="advisor__notice">' + empty + '</div>';
        for (const card of this.querySelectorAll('[data-bundle-product]')) this.updatePurchaseBundle(card, this.purchaseBundles.get(card.dataset.bundleProduct));
        this.resultsNode.insertAdjacentHTML('beforeend', this.extrasMarkup());
        this.statusNode.textContent = found.length ? found.length + (found.length === 1 ? ' passendes Produkt' : ' passende Produkte') : '';
      } catch (error) {
        if (error.name === 'AbortError' || generation !== this.generation) return;
        this.statusNode.textContent = 'Das Laden hat nicht geklappt. Bitte versuche es erneut.';
        this.resultsNode.innerHTML = '<button class="button button--secondary" data-advisor-retry type="button">Erneut versuchen</button>';
      } finally {
        if (generation === this.generation) this.resultsNode.removeAttribute('aria-busy');
      }
    }
    cardMarkup(product) {
      const bundle = this.purchaseBundles?.get(String(product.id));
      const purchase = bundle ? this.purchaseBundleMarkup(bundle) :
        (this.answers?.project === 'wallpaper' && this.answers.paperArea?.valid && !this.answers.paperArea.skipped && !product.isPhoto ? '<p class="advisor__bundle-note">Keine sichere automatische Empfehlung für diese Maße oder die verfügbare Rollenmenge. Bitte prüfe die Angaben auf der Produktseite.</p>' : '') +
        (this.answers?.project === 'film' && this.answers.filmArea?.valid && !this.answers.filmArea.skipped ? '<p class="advisor__bundle-note">Keine sichere automatische Empfehlung für diese Maße. Bitte prüfe Rollengröße, Verfügbarkeit und Zuschnitt auf der Produktseite.</p>' : '') +
        '<p class="advisor__price">' + (product.priceVaries ? 'Ab ' : '') + escape(product.price) + '</p><p class="advisor__tax">inkl. MwSt.</p>' + this.openButton(product, false);
      return '<article class="advisor__card' + (this.answers?.project === 'wallpaper' ? ' advisor__card--wallpaper' : '') + '"' + (bundle ? ' data-bundle-product="' + product.id + '"' : '') + '>' + this.openButton(product, true) + '<div class="advisor__card-info"><h3>' + escape(product.title) + '</h3>' + purchase + '</div></article>';
    }

    purchaseBundleMarkup(bundle) {
      const number = n => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(n);
      const label = item => item.label || (bundle.requiredLitres === null ? 'Eimer' : number(item.units / 100) + '-L-Eimer');
      return '<div class="advisor__bundle">' + (bundle.note ? '<p class="advisor__bundle-note">' + escape(bundle.note) + '</p>' : '') + (bundle.requiredLitres === null ? '' : '<p class="advisor__bundle-note">Bedarf: ' + number(bundle.requiredLitres) + ' L</p>') +
        bundle.items.map(item => '<div class="advisor__bundle-row"><span>' + escape(label(item)) + '</span><div class="advisor__bundle-quantity">' +
          '<button type="button" data-bundle-adjust="-1" data-variant-id="' + item.id + '" aria-label="' + escape(label(item)) + ' entfernen">−</button>' +
          '<output data-bundle-quantity="' + item.id + '" aria-live="polite">' + item.quantity + '</output>' +
          '<button type="button" data-bundle-adjust="1" data-variant-id="' + item.id + '" aria-label="' + escape(label(item)) + ' hinzufügen">+</button></div></div>').join('') +
        '<p class="advisor__bundle-total" data-bundle-total aria-live="polite"></p><p class="advisor__price" data-bundle-price></p>' +
        '<p class="advisor__tax">Gesamtpreis inkl. MwSt.</p><button type="button" class="button advisor__product-button" data-advisor-add-bundle>In den Warenkorb</button>' +
        '<p class="advisor__bundle-status" data-bundle-status role="status"></p></div>';
    }
    updatePurchaseBundle(card, bundle) {
      const total = bundle.items.reduce((sum, item) => sum + item.units * item.quantity, 0) / 100;
      const count = bundle.items.reduce((sum, item) => sum + item.quantity, 0);
      const price = bundle.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const number = n => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(n);
      for (const item of bundle.items) {
        card.querySelector('[data-bundle-quantity="' + item.id + '"]').textContent = item.quantity;
        for (const button of card.querySelectorAll('[data-variant-id="' + item.id + '"]')) {
          button.disabled = !!this.cartBusy || (Number(button.dataset.bundleAdjust) < 0 ? item.quantity === 0 : item.quantity >= item.max);
        }
      }
      card.querySelector('[data-bundle-total]').textContent = 'Gesamt: ' + (bundle.requiredLitres === null ? number(count) + (['film', 'wallpaper'].includes(bundle.kind) ? (count === 1 ? ' Rolle' : ' Rollen') : ' Eimer') : number(total) + ' L');
      card.querySelector('[data-bundle-price]').textContent = new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.config.currency }).format(price / 100);
      card.querySelector('[data-advisor-add-bundle]').disabled = !!this.cartBusy || count === 0;
      card.querySelector('[data-bundle-status]').textContent = count === 0 ? 'Bitte wähle mindestens ' + (['film', 'wallpaper'].includes(bundle.kind) ? 'eine Rolle.' : 'einen Eimer.') :
        ['film', 'wallpaper'].includes(bundle.kind) && count < bundle.requiredQuantity ? 'Deine Auswahl liegt unter der berechneten Rollenmenge.' :
        bundle.requiredLitres !== null && total < bundle.requiredLitres ? 'Deine Auswahl liegt ' + number(bundle.requiredLitres - total) + ' L unter Deinem Bedarf.' : '';
    }
    adjustPurchaseBundle(button) {
      if (button.disabled || this.cartBusy) return;
      const card = button.closest('[data-bundle-product]'), bundle = this.purchaseBundles.get(card.dataset.bundleProduct);
      const item = bundle?.items.find(item => String(item.id) === button.dataset.variantId);
      if (!item) return;
      item.quantity = Math.max(0, Math.min(item.max, item.quantity + Number(button.dataset.bundleAdjust)));
      this.updatePurchaseBundle(card, bundle);
    }
    setCartBusy(busy) {
      this.cartBusy = busy;
      for (const node of this.querySelectorAll('[data-bundle-product]')) this.updatePurchaseBundle(node, this.purchaseBundles.get(node.dataset.bundleProduct));
      for (const button of this.querySelectorAll('[data-advisor-add-extra]')) {
        const product = this.config.extras[button.dataset.advisorAddExtra];
        button.disabled = busy || !product?.available || !Number.isSafeInteger(product.variant);
      }
    }
    async addToCart(button) {
      if (button.disabled || this.cartBusy) return;
      const extraKey = button.dataset.advisorAddExtra;
      const card = button.closest(extraKey ? '[data-advisor-extra]' : '[data-bundle-product]');
      let items;
      if (extraKey) {
        const product = this.config.extras[extraKey];
        if (!product?.available || !Number.isSafeInteger(product.variant)) return;
        items = [{ id: product.variant, quantity: 1 }];
      } else {
        const bundle = this.purchaseBundles.get(card.dataset.bundleProduct);
        items = bundle?.items.filter(item => item.quantity > 0).map(item => ({ id: item.id, quantity: item.quantity }));
      }
      if (!items?.length) return;
      const status = card.querySelector('[data-bundle-status], [data-extra-cart-status]');
      this.setCartBusy(true);
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Wird hinzugefügt …';
      status.textContent = '';
      let added = false;
      try {
        const cart = document.querySelector('cart-drawer');
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map(section => section.id);
          body.sections_url = location.pathname;
          cart.setActiveElement(button);
        }
        const response = await fetch(this.url('cart/add.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || 'Die gewünschte Menge ist derzeit nicht verfügbar.');
        added = true;
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kaufberater', cartData: data });
        if (cart && body.sections.every(id => data.sections?.[id])) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          location.assign(this.url('cart').href);
        }
      } catch (error) {
        status.textContent = added ? 'Hinzugefügt. Bitte öffne den Warenkorb, um Deine Auswahl zu prüfen.' :
          (error instanceof TypeError ? 'Das Hinzufügen konnte nicht bestätigt werden.' : error.message || 'Das Hinzufügen konnte nicht bestätigt werden.') + ' Bitte prüfe Deinen Warenkorb, bevor Du erneut hinzufügst.';
      } finally {
        const message = status.textContent;
        this.setCartBusy(false);
        button.removeAttribute('aria-busy');
        button.textContent = 'In den Warenkorb';
        status.textContent = message || (added ? (extraKey ? 'Das Extra wurde zum Warenkorb hinzugefügt.' : 'Deine Auswahl wurde zum Warenkorb hinzugefügt.') : '');
      }
    }
    openButton(product, imageOnly = false, { label = 'Produkt ansehen', className = '' } = {}) {
      return '<button type="button" class="' + (className || (imageOnly ? 'advisor__product-image' : 'button advisor__product-button')) + '" data-advisor-open data-product-url="' + escape(product.url) + '" aria-label="' + escape(product.title + ' ansehen') + '">' +
        (imageOnly ? (product.image ? '<img src="' + escape(product.image) + '" alt="' + escape(product.title) + '" loading="lazy" width="600" height="600">' : '<span>Produkt ansehen</span>') : escape(label)) +
        '<span class="loading__spinner hidden"><span class="advisor__spinner"></span></span></button>';
    }
    async openProduct(button) {
      if (button.getAttribute('aria-disabled') === 'true') return;
      try {
        await customElements.whenDefined('quick-add-modal');
        await document.getElementById(this.dataset.modalId).show(button);
      } catch (_) {
        this.statusNode.textContent = 'Die Produktansicht konnte nicht geladen werden. Bitte versuche es erneut.';
        button.focus();
      }
    }
    extrasMarkup() {
      const keys = extrasFor(this.answers).filter((key) => this.config.extras[key]);
      if (!keys.length) return '';
      const title = this.answers.project === 'paint' ? 'Empfohlene Werkzeuge' : 'Extras für die Verarbeitung';
      return '<section class="advisor__extras"><h2>' + title + '</h2><p>Für die Verarbeitung empfehlen wir:</p><div class="advisor__extras-grid">' + keys.map((key) => {
        const product = this.config.extras[key];
        const url = product.url + (product.variant ? (product.url.includes('?') ? '&' : '?') + 'variant=' + product.variant : '');
        const heading = '<h3>' + escape(EXTRAS[key]) + '</h3>';
        const title = this.openButton({ ...product, url }, false, { className: 'advisor__extra-open', label: product.title + (product.variantTitle ? ' · ' + product.variantTitle : '') });
        const action = Number.isSafeInteger(product.variant)
          ? '<button type="button" class="button advisor__product-button" data-advisor-add-extra="' + key + '" ' + (!product.available || this.cartBusy ? 'disabled' : '') + '>' + (product.available ? 'In den Warenkorb' : 'Ausverkauft') + '</button>'
          : this.openButton({ ...product, url }, false, { label: 'Variante wählen' });
        return '<article class="advisor__extra" data-advisor-extra="' + key + '">' + heading + (product.image ? '<img src="' + escape(product.image) + '" alt="" loading="lazy" width="180" height="180">' : '') + '<p>' + title + '</p><p>' + escape(product.price) + '</p>' + action + '<p class="advisor__bundle-status" data-extra-cart-status role="status"></p></article>';
      }).join('') + '</div></section>';
    }
  }
  customElements.define('kauf-berater', KaufBerater);
})();
